import HighlightComponent from "../components/Highlight/Highlight";
import SkillsetComponent from "../components/Skillset/Skillset";
import CertificationsComponent from "../components/Certifications/Certifications";
import AwardsComponent from "../components/Awards/Awards";
import ProjectsCollageComponent from "../components/ProjectsCollage/ProjectsCollage";
import MemoriesComponent from "../components/Memories/Memories";
import MyTrainingsComponent from "../components/MyTrainings/MyTrainings";

export default function HomePage() {
  
  return (
    <>
      <HighlightComponent />
      <SkillsetComponent />

      <CertificationsComponent />
      <AwardsComponent />

      <ProjectsCollageComponent />

      <MemoriesComponent />

      <MyTrainingsComponent />
    </>
  );
}
